// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import contactInteractionEntity from './entities/contact-interaction.json';
import contactInteractionMenu from '../pages/contact-interaction/menu.json';
import contactInteractionFullForm from '../pages/contact-interaction/forms/full.json';
import contactInteractionContextForm from '../pages/contact-interaction/forms/context.json';
import contactInteractionMiniForm from '../pages/contact-interaction/forms/mini.json';
import contactInteractionLookupForm from '../pages/contact-interaction/forms/lookup.json';
import contactInteractionTableView from '../pages/contact-interaction/views/table.json';
import contactInteractionCardsView from '../pages/contact-interaction/views/cards.json';
import contactInteractionCalendarView from '../pages/contact-interaction/views/calendar.json';
import contactInteractionDashboardView from '../pages/contact-interaction/views/dashboard.json';

/** Тип запису «Взаємодія з контактом» зі сторінками пакета: меню, форми та подання з pages/contact-interaction/. */
export const contactInteractionDefinition: IRecordTypeDefinition = {
  ...contactInteractionEntity,
  views: assembleViewSet({
      table: contactInteractionTableView,
      cards: contactInteractionCardsView,
      calendar: contactInteractionCalendarView,
      dashboard: contactInteractionDashboardView,
  }),
  form: contactInteractionFullForm,
  forms: { full: contactInteractionFullForm, context: contactInteractionContextForm, mini: contactInteractionMiniForm, lookup: contactInteractionLookupForm },
  menu: contactInteractionMenu,
} as IRecordTypeDefinition;
